export default "__VITE_ASSET__BMbqG2fB__"